import { Component } from "react";
import '../assets/css/formulario.css'
import iconUser from "../assets/imgs/user.svg";
import iconGroup from "../assets/imgs/group.svg";
import FormularioCibbComponente, { FormularioCibbGrupo } from "./FormularioCibbComponente";

export class FormularioCibb extends Component {
    constructor(props) {
        super(props);

        var idcongreso = -1;
        var aceptaRegistro = true;

        this.state =
        {
            recaptchaToken: null,
            evento: idcongreso,
            titulo: "",
            shortitulo: "",
            isDespuesRegInicio: aceptaRegistro,
            fechaInicioInsc: "",
            fechaFinInsc: "",
            isAntesRegFin: aceptaRegistro,
            anioEvento: "",
            isRegistrado: false,
            onProcess: false,
            isLoading: false,
            integrantesGrupo: 4,
            paisesjson: [],
            tipoRegistro: 0, // 0 No select, 1 Individual, 2 Grupo
            fechaInicioEvento: null,
            fechaFinEvento: null
        };

        //this.handleChange = this.handleChange.bind(this);
        //this.handleBlur = this.handleBlur.bind(this);
        //this.getDatosEspol = this.getDatosEspol.bind(this);
        //this.getDatosBienestar = this.getDatosBienestar.bind(this);
        //this.getCiudades = this.getCiudades.bind(this);
        //this.setNomPais = this.setNomPais.bind(this);
        //this.setPaisCedula = this.setPaisCedula.bind(this);
        //this.setNomCiudad = this.setNomCiudad.bind(this);
        //this.setCibbValor = this.setCibbValor.bind(this);
        //this.esGraduadoPregrado = this.esGraduadoPregrado.bind(this);
        //this.esGraduadoPostgrado = this.esGraduadoPostgrado.bind(this);
        //this.esEstudiantePostgrado = this.esEstudiantePostgrado.bind(this);
        //this.setModoInformadoDet = this.setModoInformadoDet.bind(this);
        //this.setTipoInstitucionDet = this.setTipoInstitucionDet.bind(this);
        //this.setTipoParticipanteDet = this.setTipoParticipanteDet.bind(this);
        //this.setTipoEstudianteDet = this.setTipoEstudianteDet.bind(this);
        //this.setTipoParticipacionDet = this.setTipoParticipacionDet.bind(this);
        //this.setEsEspolDet = this.setEsEspolDet.bind(this);
        //this.setEsPostgradoDet = this.setEsPostgradoDet.bind(this);
        //this.getCelularFromWsAlumni = this.getCelularFromWsAlumni.bind(this);
        //this.handleRecaptchaChange = this.handleRecaptchaChange.bind(this);
        //this.formatDateString = this.formatDateString.bind(this);
        //this.showTermsTratamiento = this.showTermsTratamiento.bind(this);
    }

    getCongresoActual() {
        fetch(process.env.REACT_APP_URI_SERVER + "api/TblCongresoes/GetCIBBActual")
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                //var dto = this.state.datosFormulario;
                var idcongreso = response["idcongreso"];
                //dto["idCongreso"] = idcongreso;
                var inicioInscripcion = Date.parse(response["fechainicioinscripcion"]);
                var finInscripcion = Date.parse(response["fechafininscripcion"]);
                var inicioEvento = Date.parse(response["fechainicio"]);
                var finEvento = Date.parse(response["fechafin"]);
                var fechaActual = Date.now();
                var tituloCorto = `${response["descripcion"].split(" ")[0]} CIBB ${response["anio"]}`
                //var aceptaRegistro = inicioInscripcion <= fechaActual && fechaActual <= finInscripcion;
                //console.log(aceptaRegistro);
                this.setState({
                    titulo: response["descripcion"],
                    shortitulo: tituloCorto,
                    evento: idcongreso,
                    anioEvento: response["anio"],
                    isDespuesRegInicio: inicioInscripcion <= fechaActual,
                    fechaInicioInsc: String(response["fechainicioinscripcion"]).split("T")[0],
                    isAntesRegFin: fechaActual <= finInscripcion,
                    fechaFinInsc: String(response["fechafininscripcion"]).split("T")[0],
                    fechaInicioEvento: inicioEvento,
                    fechaFinEvento: finEvento,

                    //datosFormulario: dto
                });
            })
            .catch(error => {
                console.log("Error: ", error);
            })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.paisesjson.length === 0) {
            this.getPaises();
        }
    }

    getPaises() {
        console.log("Registro Evento ", this.state.evento)
        //console.log("Llamando funcion get paises");
        fetch("https://ws.espol.edu.ec/rest/api/Pais/getconciudad")
            .then(response => response.json())
            .then(responsejson => {
                this.setState({ paisesjson: responsejson });
                //console.log(this.state.datosFormulario.paises);
            });
    }

    setTipoRegistro(tipo) {
        this.setState({ tipoRegistro: tipo })
    }

    componentDidMount() {
        this.getCongresoActual();
        //this.getPaises();
    }

    renderFormulario() {

        //let iconUser = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#FFFFFF" d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z" /></svg>
        //let iconGroup = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#FFFFFF" d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z" /></svg>
        let styleButton = {}

        return (
            <>
                {this.state.tipoRegistro == 0 && <>
                    <br/>
                    <center>
                        <span style={{fontWeight: "bold", fontSize: "16pt"}}>
                            Seleccione el tipo de inscripción
                        </span>
                    </center>
                    <br /><br />
                    <div style={{display: "flex", flexWrap: "wrap", flexDirection: "row", gap: "2rem", justifyContent: "space-around"}}>
                        <div
                            className={"card-select-cibb-registro"}
                            style={{ backgroundColor:"#84ccea" }}
                            onClick={() => this.setTipoRegistro(1)}
                        >
                            <div className={"icon-card-select-cibb-registro"}>
                                <img src={iconUser} alt={"Ícono de registro individual"} />
                                {/*{iconUser}*/}
                            </div>
                            <span>Registro individual</span>
                        </div>
                        <div
                            className={"card-select-cibb-registro"}
                            style={{ backgroundColor: "#3f97d0" }}
                            onClick={() => this.setTipoRegistro(2)}
                        >
                            <div className={"icon-card-select-cibb-registro"}>
                                <img src={iconGroup} alt={"Ícono de registro grupal"} />
                                {/*{iconUser}*/}
                            </div>
                            <span>Registro en grupo</span>
                        </div>
                    </div>
                </>}
                {this.state.tipoRegistro != 0 && <>
                    {this.renderFormularioComponent()}
                </>
                }
            </>
        )
    }

    renderFormularioComponent() {
        return (
            <>
                <div
                    style={{ width: "fit-content", verticalAlign: "center", cursor: "pointer", display: "flex", alignItems: "center", color: "#5084C1"}}
                    onClick={() => this.setTipoRegistro(0)}
                >
                    <span className="material-symbols-outlined">
                        &#xe5c4;
                    </span>
                    <span style={{fontWeight: "bold"}}>Cambiar tipo de registro</span>
                </div>
                <br />
                {
                    this.state.tipoRegistro == 1 ?
                        <FormularioCibbComponente
                            aceptaRegistro={true}
                            evento={this.state.evento}
                            titulo={this.state.titulo}
                            shortitulo={this.state.shortitulo}
                            fechaInicioInsc={this.state.fechaInicioInsc}
                            fechaFinInsc={this.state.fechaFinInsc}
                            anioEvento={this.state.anioEvento}
                            paises={this.state.paisesjson}
                            fechaInicioEvento={this.state.fechaInicioEvento}
                            fechaFinEvento = {this.state.fechaFinEvento}
                        />
                        :
                        <FormularioCibbGrupo
                            aceptaRegistro={true}
                            evento={this.state.evento}
                            titulo={this.state.titulo}
                            shortitulo={this.state.shortitulo}
                            fechaInicioInsc={this.state.fechaInicioInsc}
                            fechaFinInsc={this.state.fechaFinInsc}
                            anioEvento={this.state.anioEvento}
                            paises={this.state.paisesjson}
                            integrantesGrupo={this.state.integrantesGrupo}
                            fechaInicioEvento={this.state.fechaInicioEvento}
                            fechaFinEvento={this.state.fechaFinEvento}
                        />
                }
                
            </>
        )
    }

    render() {
        var contenido = (this.state.paisesjson.length > 0 &&
            this.state.evento !== -1) ?
            <>
                <center>
                    {/*<h4 style={{ marginTop: "10px" }}>VII Congreso Internacional de Biotecnolog&iacute;a y Biodiversidad 2025</h4>*/}
                    <h4 style={{ marginTop: "10px" }}>{this.state.titulo}</h4>
                    {/*<h5>CIBB 2025</h5>*/}
                    {/*<h5>- MODALIDAD VIRTUAL -</h5>*/}
                </center>
                {/*<br />*/}
                {/*<h5>Formulario de Registro: VII CIBB 2025</h5>*/}
                <br />
                {this.renderFormulario()}
            </>

            :
            (this.state.evento == 0 ?
                <div>
                    <span>Evento no disponible</span>
                </div>
                :
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", fontSize: "16pt", marginTop: "10px" }}>
                    <div className="spinner-border" role="status">
                        <span className="visually-hidden"></span>
                    </div>
                    <span><strong>Cargando Formulario...</strong></span>
                </div>
            )

        return (
            <div>
                {contenido}
            </div>
        );
    }

}